// Module
var code = "<kid id=\"{{ componentId }}\" ng-attr-name=\"{{ componentId || component.key }}\" ng-change=\"changeValue()\" ng-disabled=\"readOnly || component.disabled\" ng-model=\"data[component.key]\" ng-required=\"isRequired(component)\" options=\"component.options\" prefix=\"{{ component.kprefix }}\"></kid> ";
// Exports
export default code;